'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glamor = require('@headspace/glamor');

var _colors = require('./colors');

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var utils = {};
['center', 'left', 'right'].forEach(function (pos) {
  utils[pos + 'TextAlign'] = (0, _glamor.css)({
    textAlign: pos
  });
});
Object.keys(colors).forEach(function (color) {
  if (typeof colors[color] !== 'string') return;
  utils[color + 'Color'] = (0, _glamor.css)({
    color: colors[color]
  });
});
utils.uppercase = (0, _glamor.css)({
  textTransform: 'uppercase'
});
utils.capitalize = (0, _glamor.css)({
  textTransform: 'capitalize'
});
utils.letterSpacingNormal = (0, _glamor.css)({
  letterSpacing: 'normal'
});
utils.linkHover = (0, _glamor.css)({
  cursor: 'pointer',
  opacity: 1,
  ':hover': {
    opacity: 0.8
  }
});
exports.default = utils;